// extracted by mini-css-extract-plugin
module.exports = {"headline":"ProductReviews_headline__g77z3","review":"ProductReviews_review__CgmtY","signature":"ProductReviews_signature__VVjI2"};